import Alpine from 'alpinejs';
import { useForm } from 'axios-form-handler';
document.addEventListener('alpine:init', () => {
  Alpine.data('contactForm', (locale, honeypot, page_id, subject) => ({
    honeypot,
    init() {
      let form = {
        full_name: null,
        locale,
        email: null,
        subject,
        page_id,
        message: null,
        terms_accepted: true,
      };

      if (honeypot?.enabled) {
        form[honeypot.nameFieldName] = '';
        form[honeypot.validFromFieldName] = honeypot.encryptedValidFrom;
      }

      this.form = useForm(form);
    },
    onSubmit() {
      // mutate in place so references remain intact
      this.form.post('/contact/', {
        onSuccess: () => {
          Alpine.store('ctaModal').close();
          this.form.reset();
        },
      });
    },
  }));
  Alpine.data('formElement', (form, name) => ({
    error: null,
    init() {
      this.form = form;
      this.$watch('form.errors', (errors) => {
        if (errors[name] == null) {
          this.error = null;
          return;
        }

        this.error = errors[name];
      });
    },
  }));
});
